import $ from 'jquery';
import Toggler from '../utils/toggler';
import { onResize } from '../utils/window';
import { frame, unframe } from '../utils/drawing';
import init from '../init';

export default function headerSection() {
	const $html = $('html');
	const $nav = $('#header-nav');
	
	(function initMenu() {
		const toggleDelay = 300;

		const $root = $nav.find('.header-nav_root');
		const $rootItems = $root.children('.-has-children');
		const $background = $nav.find('.header-nav_background');

		let $currentMenu = null;
		let currentToggler = null;
		let backgroundFrame;
		let timeout;

		function setBackgroundHeight() {
			if ($currentMenu) {
				$background.css('height', $currentMenu.outerHeight() + 'px');
				$html.addClass('is-header-open');
			} else {
				$background.css('height', '');
				$html.removeClass('is-header-open');
			}
		}

		$rootItems.each(function() {
			const $item = $(this);
			const $menu = $item.children('ul');

			const open = false;
			const transition = parseFloat($menu.css('transition-duration')) ? 'css' : false;
			const toggler = new Toggler($menu, { open, transition });

			function openMenu() {
				if ($currentMenu !== $menu) {
					toggler.open();

					if (currentToggler) {
						currentToggler.close();
					}

					$currentMenu = $menu;
					currentToggler = toggler;

					unframe(backgroundFrame);
					setBackgroundHeight();
				}
			}

			function closeMenu() {
				if ($currentMenu === $menu) {
					toggler.close();

					$currentMenu = null;
					currentToggler = null;

					backgroundFrame = frame(() => setBackgroundHeight());
				}
			}

			$item.on('mouseover', function() {
				clearTimeout(timeout);
				if (currentToggler && currentToggler.isOpen) {
					openMenu();
				} else {
					timeout = setTimeout(openMenu, toggleDelay);
				}
			});

			$item.on('mouseout', function() {
				clearTimeout(timeout);
				timeout = setTimeout(closeMenu, toggleDelay);
			});
		});

		onResize(setBackgroundHeight);
	}());

	(function initSearch() {
		const $search = $nav.find('.header-nav_search');
		const $searchField = $nav.find('.header-nav_search_field');
		const $searchButton = $search.find('.header-nav_search_button');

		const open = false;
		const transition = parseFloat($search.css('transition-duration')) ? 'css' : false;
		const toggler = new Toggler($search, { open, transition });

		toggler.on('open', () => $searchField.trigger('focus'));
		toggler.on('toggle', () => $nav.toggleClass('is-search-open', toggler.isOpen));

		$searchButton.on('click', function(e) {
			if (!toggler.isOpen) {
				e.preventDefault();
				toggler.open();
			}
		});

		$search.on('click', (e) => e.stopPropagation());
		$html.on('click', () => toggler.close());

	}());

	$(function(){
		const siteUrl = $('.header_logo > a').attr('href');
		const $cart = $('.cart');
		const $cartBody = $cart.find('.cart_body');
		$.get(`${siteUrl}ajax/cart`, '', function(c) {
			$cartBody.html(c);
			init($cartBody[0]);
		});
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js